import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PresentPC from 'components/pages/Conf/PresentPC';
import PresentSP from 'components/pages/Conf/PresentSP';
import AppContext from 'fluxes/context';

import {
  CHANGE_VALID,
  UPDATE_RECEIPT_ID,
} from 'fluxes/actions';

import MeasureEvent from 'utils/measureEvent';
import { postRegisterRequestApi } from 'utils/api';
import { THANKS_URL, MEASURE_MAP } from 'utils/constant';
import {
  useDirectTransCheck,
  useWindowDimensions,
  getChoiceLabel,
  useIECheck,
  isFatalApiError,
  isSchemaValid,
  randomID,
  scrollTop,
} from 'utils';

const Conf = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  const [ receiptID, setReceiptID ] = useState(state.receiptID);
  const [ strWorkCategory, setWorkCategory ] = useState('');
  const [ isApiError, setIsApiError ] = useState(false);
  const [ showLoading, setShowLoding ] = useState(false);
  const history = useHistory();

  const {
    workCategory,
    workCategoryOtherDetail,
    workDetailText,
    employmentPlacementDispatching,
    companyNameText,
    dept,
    chargePersonNameText,
    tel,
    email,
    address,
    ekiCd,
    ekiName,
    isRegistered,
    clickID,
    mediaID,
  } = state;

  // 直接遷移チェック
  useDirectTransCheck({ state });

  // 依頼ID発行
  useEffect(()=>{
    const id = randomID();
    setReceiptID(`OLOD-${id}`);
  }, []);

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  useEffect(() => {
    if (workCategory === 'E' && !!workCategoryOtherDetail) {
      setWorkCategory("その他（" + workCategoryOtherDetail + "）");
    } else {
      setWorkCategory(getChoiceLabel('workCategoryList', workCategory));
    }
  }, []);

  // ボタン押下
  // state更新処理
  const onClickMainButton = {
    prev: () => {
      scrollTop();
    },
    next: (e) => {
      // イベント計測
      MeasureEvent(
        {
          linkTrackVars: MEASURE_MAP.EVENT_83.linkTrackVars,
          linkTrackEvents: MEASURE_MAP.EVENT_83.linkTrackEvents,
          events: MEASURE_MAP.EVENT_83.events,
        },
        MEASURE_MAP.EVENT_83.name,
      );
      scrollTop();
      setShowLoding(true);
      
      // 依頼IDを保存
      dispatch({
        type: UPDATE_RECEIPT_ID,
        updReceiptID: { receiptID },
      });

      const params = {
        workCategory: strWorkCategory,
        workDetailText,
        employmentPlacementDispatching,
        companyNameText,
        dept,
        chargePersonNameText,
        tel,
        email,
        address,
        ekiCd,
        ekiName,
        receiptID,
        clickID,
        mediaID,
      };
    
      // データ登録処理
      e.preventDefault();
      // 二重登録
      if(isRegistered) {
        setIsApiError(true);
        return false;
      };
      const [ isPostValid ] = isSchemaValid({ path, target: params });
      if(!isPostValid){
        setIsApiError(true);
        return false;
      };
      // ok  
      dispatch({
        type: CHANGE_VALID, 
        path,
        valid: isPostValid,
      });

      // 更新処理
      postRegisterRequestApi({ params })
        .then(() => {
          history.push(THANKS_URL);
        })
        .catch(err => {
          //  派遣依頼登録 FATELエラーチェック
          const isFatal = isFatalApiError(err);
          setIsApiError(isFatal);
          if(isFatal) throw err;
        
          // 400エラーは基本的に起きないためFATAL
          if(err.response.status === 400) {
            setIsApiError(true);
            return false;
          };
          return false;
        });
      return true;
    },
  };

  // 画面表示用テキスト
  const confList = [
    { text: 'ご検討の職種',
      children: strWorkCategory,
      questionMark: true,
      popUpTitle: '職種について',
      popUpDetail: (
        <span>
          <p>法律上の派遣禁止業務（港湾運送・建設・警備・医療・士業）や製造業務等、一部の業務は弊社のサービスの対象外となる可能性がございます。</p>
        </span>
      ),
    },
    { text: '企業名',
      children: companyNameText,
      questionMark: false,
    },
    { text: '派遣先部課名',
      children: dept,
      questionMark: true,
      popUpTitle: '',
      popUpDetail: (
        <span>
          派遣先部課名がない場合は「なし」と入力してください
        </span>),
    },
    { text: 'ご担当者名',
      children: chargePersonNameText,
      questionMark: false,
    },
    { text: '電話番号',
      children: tel,
      questionMark: false,
    },
    { text: 'メールアドレス',
      children: email,
      questionMark: false,
    },
    { text: '派遣先住所',
      children: address,
      questionMark: false,
    },
    { text: '派遣先最寄り駅',
      children: ekiName,
      questionMark: false,
    },
    { text: '紹介予定派遣のみの希望',
      children: employmentPlacementDispatching ? '希望する' : '希望しない',
      questionMark: true,
      popUpTitle: '紹介予定派遣について',
      popUpDetail: (
        <span>
          <p>
            「紹介予定派遣」とは、社員として採用することを前提に、派遣社員を一定期間受入、派遣期間中に社員としての適性を見極めることができる仕組みです。
            <br />
            <br />
            詳細は
            <a className="link-grey" href="/sol/contents/client/ttoh/" target="_blank" rel="noopener noreferrer">こちら</a>
          </p>
        </span>),
    },
    { text: 'ご依頼内容の詳細',
      children: workDetailText,
      questionMark: false,
      popUpTitle: '',
      popUpDetail: '',
    }
  ];


  // 画面表示
  return isSp ? (
    <PresentSP 
      confList={confList}
      
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
    />
  ) : (
    <PresentPC 
      confList={confList}

      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      showLoading={showLoading}
    />
  );
};

export default Conf;
